jQuery(function () {
    jQuery('.navbar__dropdown').on('mouseenter', function () {
        var dropdownId = jQuery(this).attr('data-dropdown');
        jQuery(dropdownId).removeClass('navbar__dropdown-options--hidden').addClass('navbar__dropdown-options--visible');
    });

    jQuery('.navbar__dropdown').on('mouseleave', function () {
        var dropdownId = jQuery(this).attr('data-dropdown');
        jQuery(dropdownId).removeClass('navbar__dropdown-options--visible').addClass('navbar__dropdown-options--hidden');
    });

    jQuery('.navbar__dropdown-options').on('mouseenter', function () {
        jQuery(this).removeClass('navbar__dropdown-options--hidden').addClass('navbar__dropdown-options--visible');
    });

    jQuery('.navbar__dropdown-options').on('mouseleave', function () {
        var dropdownOptions = jQuery(this);
        dropdownOptions.removeClass('navbar__dropdown-options--visible').addClass('navbar__dropdown-options--hidden');
    });
});